import { Box, Button, Grid, LinearProgress, Paper, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import TextEditorWithTitle from './components/TextEditorWithTitle'
import { getQuestionReviews, updateReview } from '../../services/subjects/unlimitedQuestionReview'
import Grid2 from '@mui/material/Unstable_Grid2'

function QeuestionExplanation() {

    const [loading, setLoading] = useState(false)
    const [originalSavedQuestionData, setOriginalSavedQuestionData] = useState([])
    const [questionEditorState, setQuestionEditorState] = useState({})
    const [question, setQuestion] = useState('')

    const navigate = useNavigate();



    const {questionId} = useParams()
   
    console.log({questionId})

    useEffect(() => {
      if (questionId) {
        loadQuestionExplanation(questionId);
      }
    }, [questionId]);

    const loadQuestionExplanation = async (questionId) => {
        if(!questionId){
            return;
        }
        if(loading) return;
        if(isNaN(questionId)) return;
        try{
            setLoading(true)
            const {data, status} = await getQuestionReviews(0, 20, questionId, false, false, null);
            if (status == 200) {
                setOriginalSavedQuestionData(data);
            } else {
                console.error('Failed to fetch question explanation');
            }
        }catch(err){
        }finally{
            setLoading(false)
        }
    }

    const onEditQuestionReview = (index,) => {
        localStorage.setItem("questionReview", JSON.stringify(originalSavedQuestionData[index]));
        const {id} = originalSavedQuestionData[index]
        navigate(`${id}`)
    }

    const onApproveReview = async(index) => {
        if(loading) return;
        try{
            const {questionReviewStatus, editedQuestionReview, editedQuestionReviewEditorState, id} = originalSavedQuestionData[index];
            setLoading(true);
            let updatedReviews = {}
            if (questionReviewStatus === "PENDING") {
              updatedReviews = {
                // ...originalSavedQuestionData[index],
                questionReviewStatus: "APPROVED",
              };
            } else if (questionReviewStatus === "EDIT_REQUESTED") {
                updatedReviews = {
                // ...originalSavedQuestionData[index],
                questionReviewStatus: "APPROVED",
                questionReview : editedQuestionReview,
                questionReviewEditorState: editedQuestionReviewEditorState,
                editedQuestionReview: "",
                editedQuestionReviewEditorState : ""
              };
            }
            
            const {status , data} = await updateReview(id, updatedReviews);
            if(status === 200){
                const updatedData = [...originalSavedQuestionData];
                updatedData[index] = data;
                setOriginalSavedQuestionData(updatedData);
            }
        }catch(err){
            console.log(err)
        }finally{
            setLoading(false)
        }
    }

    const onAddExplanation = () => {
        navigate(`-1`)
    }
    
   
    
  return (
    <Grid2 container spacing={2} sx={{ padding: 2 }}>
      {loading && (
        <LinearProgress style={{ display: loading ? "block" : "none" }} />
      )}
      <Grid2 xs={12} sm={12} md={12} lg={12} xl={12}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 2,
            flexDirection: "row",
          }}
        >
          <Typography
            variant="h4"
            style={{
              marginBottom: "30px",
            //   fontFamily: "sans-serif",
            //   fontSize: "140%",
            //   fontWeight: "bolder",
            }}
          >
            Question Explanation
          </Typography>
        </Box>
      </Grid2>

      {originalSavedQuestionData.map((review, index) => {
        const {
          questionReview,
          questionReviewEditorState,
          questionReviewStatus,
          editedQuestionReview,
        } = review;

        console.log(editedQuestionReview)

        return (
          <Grid2 xs={12} sm={12} md={12} lg={12} xl={12} key={index}>
            <Paper key={index} sx={{ padding: 2, marginBottom: 2 }}>
              {/* edit button */}

              <Box sx={{ marginBottom: 2 }}>
                <Typography variant="subtitle1" gutterBottom>
                  {"Question Review"}
                </Typography>
                <div
                  dangerouslySetInnerHTML={{ __html: questionReview }}
                  key={index}
                ></div>
              </Box>

              {editedQuestionReview !== "" && editedQuestionReview !== null ? (
                <Box sx={{ marginBottom: 2 }}>
                  <Typography variant="subtitle1" gutterBottom>
                    {"Edited Question Review"}
                  </Typography>

                  <div
                    dangerouslySetInnerHTML={{ __html: editedQuestionReview }}
                    key={index}
                  ></div>
                </Box>
              ) : null}
              {/* Aprove button */}
              <Box sx={{ marginBottom: 2 , gap: 1, display: 'flex', flexDirection: 'row', marginTop: 4 }}>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => {
                      onEditQuestionReview(index);
                    }}
                  >
                    Edit
                  </Button>

                {questionReviewStatus === "PENDING" ||
                questionReviewStatus === "EDIT_REQUESTED" ? (
                  <Button
                    variant="contained"
                    color="success"
                    size="small"
                    onClick={() => {
                      onApproveReview(index);
                    }}
                  >
                    Approve
                  </Button>
                ) : null}
              </Box>
            </Paper>
          </Grid2>
        );
      })}
      {originalSavedQuestionData.length === 0 && !loading ? (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={onAddExplanation}
        >
          Add Question Explanation
        </Button>
      ) : null}
    </Grid2>
  );
}

export default QeuestionExplanation